import { render, staticRenderFns } from "./editcheckbox.vue?vue&type=template&id=dd7f71d6&"
import script from "./editcheckbox.vue?vue&type=script&lang=js&"
export * from "./editcheckbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports